export default {
    methods: {
        getDettaglioNews() {
            return {
                id: "",
                titolo: "",
                testo: "",
                dataInizio: "",
                dataFine: "",
                utente: "",
                cliente: "",
            }
        },

        getHeadersTabella() {
            return [
                { text: "Titolo", value: "titolo", sortable: false },
                { text: "Testo", value: "testo", sortable: false },
                {
                    text: "Data Inizio",
                    value: "dataInizio",
                    sortable: false,
                },
                { text: "Data Fine", value: "dataFine", sortable: false },
                { text: "Azioni", value: "", sortable: false },
            ]
        },
    }
}